import { render } from "./EmProducao.vue?vue&type=template&id=53e22570&scoped=true"
import script from "./EmProducao.vue?vue&type=script&lang=js"
export * from "./EmProducao.vue?vue&type=script&lang=js"

import "./EmProducao.vue?vue&type=style&index=0&id=53e22570&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e22570"]])

export default __exports__